import { NgClass, NgFor, NgIf } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';
import { OverlayPanelModule } from 'primeng/overlaypanel';

@Component({
  selector: 'app-enviroment-sensor',
  standalone: true,
  imports: [NgFor, NgIf, NgClass, HttpClientModule, OverlayPanelModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './enviroment.component.html'
})
export class SensorEnvironmentComponent {

  @Input()
  public slug!: string;

  public showInfo: boolean = false;

  public sensorList: any[] = [];
  public location: any = null;

  private _subscription: Subscription = new Subscription();

  constructor(private _cdr: ChangeDetectorRef) {
  }

  async ngOnInit() {
    await this._getAllData();
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private async _getAllData(): Promise<any> {
    const url_environment = `ws://192.168.104.89:8085/ws/topic/EMCO2`;
    const consumerSocket = new WebSocket(url_environment);
    
    consumerSocket.onopen = () => {
      console.log('Conexión WebSocket establecida');
    };

    consumerSocket.onmessage = (e) => {
      console.log("ENVIRONMENT SENSOR");
      const data = JSON.parse(e.data);
      console.log(e);
      console.log(data);
    };

    consumerSocket.onclose = (e) => {
      console.log("Conexion cerrada");
      console.log(e);
    };
  }
}
